import React, { useEffect, useState } from "react"
import "./styles.scss"

const BulletTabsOptions = ({ options, onChange, selectedTabs, renderTab = defaultTab }) => {
  return (
    <div className="bullet_tabs">
      {options?.map((tab) => (
        <div
          key={tab?.value}
          className={`bullet_tabs__item bullet_tabs__item${tab?.value}`}
          onClick={() => onChange(tab)}>
          {tab && tab?.label && renderTab(tab, selectedTabs)}
        </div>
      ))}
    </div>
  )
}

const defaultTab = (tab, selectedTabs) => {
  const isActive = selectedTabs.some((selectedTab) => selectedTab?.value === tab?.value)
  return <button className={`bullet_tabs__button ${isActive ? "active" : ""}`}>{tab?.label}</button>
}

export const BulletTabs = ({ options, onSelect, values, children, tab, allowMultiple = false }) => {
  const [selectedTabs, setSelectedTabs] = useState([])

  useEffect(() => {
    if (!allowMultiple) {
      setSelectedTabs([options[0]].filter(row => row))
      typeof onSelect === "function" && onSelect([options[0]].filter(row => row));
    } else {
      setSelectedTabs(options.filter(row => row))
      typeof onSelect === "function" && onSelect(options.filter(row => row));
    }
  }, [allowMultiple])

  useEffect(() => {
    if(values){
      setSelectedTabs([values])
    }
  }, [values])

  const onChangeHandler = (value) => {
    if (allowMultiple) {
      setSelectedTabs((prevSelectedTabs) => {
        const isSelected = prevSelectedTabs.some((t) => t?.value === value?.value)
        return isSelected
          ? prevSelectedTabs.filter((t) => t?.value !== value?.value)
          : [...prevSelectedTabs, value]
      })
    } else {
      setSelectedTabs([value])
      typeof onSelect === "function" && onSelect(value);
    }
  }

  useEffect(() => {
    if(allowMultiple){
      typeof onSelect === "function" && onSelect(selectedTabs)
    }
  }, [selectedTabs])

  return (
    <div className="bullets-tab-container">
      <BulletTabsOptions
        options={options}
        selectedTabs={selectedTabs}
        onChange={onChangeHandler}
        renderTab={renderTab}
      />
      {children && <div className="bullet_tabs__content">{children}</div>}
    </div>
  )
}

const renderTab = (tab, selectedTabs) => {
  const isActive = selectedTabs.some((selectedTab) => selectedTab?.value === tab?.value)
  return <button className={`bullet_tabs__button ${isActive ? "active" : ""}`}>{tab?.label}</button>
}
